import { render, staticRenderFns } from "./edit-reporters.component.html?vue&type=template&id=47164920&scoped=true&external"
import script from "./edit-reporters.component.ts?vue&type=script&lang=ts&external"
export * from "./edit-reporters.component.ts?vue&type=script&lang=ts&external"
import style0 from "./edit-reporters.component.scss?vue&type=style&index=0&id=47164920&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47164920",
  null
  
)

export default component.exports